module.exports = __webpack_public_path__ + "img/icon-home.8a44f322.svg";